/**
 * @generated SignedSource<<059497c5f1910acdb37d6f937c80758f>>
 * @relayHash a05c0aaf67cd8f0c10738234127dfc9a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0bef23b817246ce96047fb5a9ba545e88b4f5b96ddbaeec83d7ff9aa7a775b17

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceGraphQLDefaultTitleEmoji = "LIVE_PAGE_DEFAULT" | "NONE" | "%future added value";
export type ConfluenceUpdateDefaultTitleEmojiInput = {
  contentId: string;
  defaultTitleEmoji: ConfluenceGraphQLDefaultTitleEmoji;
};
export type EmojiTitleButtonUpdateDefaultTitleEmojiMutation$variables = {
  cloudId: string;
  input: ConfluenceUpdateDefaultTitleEmojiInput;
};
export type EmojiTitleButtonUpdateDefaultTitleEmojiMutation$data = {
  readonly confluence_updateDefaultTitleEmoji: {
    readonly contentId: string;
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null | undefined;
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type EmojiTitleButtonUpdateDefaultTitleEmojiMutation = {
  response: EmojiTitleButtonUpdateDefaultTitleEmojiMutation$data;
  variables: EmojiTitleButtonUpdateDefaultTitleEmojiMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "contentId"
},
v3 = {
  "kind": "ScalarField",
  "name": "success"
},
v4 = {
  "kind": "ScalarField",
  "name": "message"
},
v5 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v6 = {
  "kind": "ScalarField",
  "name": "statusCode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "EmojiTitleButtonUpdateDefaultTitleEmojiMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConfluenceUpdateDefaultTitleEmojiPayload",
        "kind": "LinkedField",
        "name": "confluence_updateDefaultTitleEmoji",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EmojiTitleButtonUpdateDefaultTitleEmojiMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConfluenceUpdateDefaultTitleEmojiPayload",
        "kind": "LinkedField",
        "name": "confluence_updateDefaultTitleEmoji",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "a05c0aaf67cd8f0c10738234127dfc9a",
    "id": "0bef23b817246ce96047fb5a9ba545e88b4f5b96ddbaeec83d7ff9aa7a775b17",
    "metadata": {},
    "name": "EmojiTitleButtonUpdateDefaultTitleEmojiMutation",
    "operationKind": "mutation",
    "text": "mutation EmojiTitleButtonUpdateDefaultTitleEmojiMutation($cloudId:ID!,$input:ConfluenceUpdateDefaultTitleEmojiInput!){confluence_updateDefaultTitleEmoji(cloudId:$cloudId,input:$input){contentId,success,errors{message,extensions{__typename,errorType,statusCode,...on BulkMutationErrorExtension{id}}}}}"
  }
};
})();

(node as any).hash = "576a3256d35e9e9e85e6a3da9d2bd499";

export default node;
